var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.155895 0.129218C0.344858 -0.0274098 0.640555 -0.0416487 0.848924 0.086501L0.908621 0.129218L5.5 3.93471L10.0914 0.129218C10.2803 -0.0274098 10.576 -0.0416487 10.7844 0.086501L10.8441 0.129218C11.0331 0.285845 11.0502 0.530941 10.8956 0.703654L10.8441 0.753135L5.87636 4.87078C5.6874 5.02741 5.3917 5.04165 5.18333 4.9135L5.12364 4.87078L0.155895 0.753135C-0.0519649 0.580845 -0.0519649 0.301508 0.155895 0.129218Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDownarrow);
export default __webpack_public_path__ + "static/media/filter_downarrow.732c77517f6766e6f7263a034b87e435.svg";
export { ForwardRef as ReactComponent };